/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BeneficiarioDossieAliases {
  CARD_1 = 'card-1',
  CARD_DADOS = 'card-dados',
  CARD_SERVICOS = 'card-servicos',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATA_DOCUMENTO_RESPONSIVO = 'data-documento-responsivo',
  DECK_CONSULTA_BENEFICIARIO = 'deck-consulta-beneficiario',
  DECK_DOSSIE = 'deck-dossie',
  DECK_RESPONSIVO = 'deck-responsivo',
  FETCH_0 = 'fetch-0',
  FETCH_BENEFICIARIO = 'fetch-beneficiario',
  FETCH_CONSULTA_BENEFICIARIO = 'fetch-consulta-beneficiario',
  FETCH_DOSSIE = 'fetch-dossie',
  FETCH_DOSSIE_CONTRATO_DOCUMENTOS = 'fetch-dossie-contrato-documentos',
  FETCH_MENSAGEM_CARENCIA = 'fetch-mensagem-carencia',
  FETCH_PRODUTO = 'fetch-produto',
  FETCH_SERVICOS = 'fetch-servicos',
  FIELD_0 = 'field-0',
  FIELD_ABRANGENCIA_GEOGRAFICA = 'field-abrangencia-geografica',
  FIELD_BENEFICIARIO = 'field-beneficiario',
  FIELD_CARENCIA_CONSULTA = 'field-carencia-consulta',
  FIELD_CARTEIRA = 'field-carteira',
  FIELD_CODIGO_ANTERIOR = 'field-codigo-anterior',
  FIELD_CONTRATO = 'field-contrato',
  FIELD_DATA_ADESAO = 'field-data-adesao',
  FIELD_DATA_DOCUMENTO = 'field-data-documento',
  FIELD_DATA_INCLUSAO_OPERADORA = 'field-data-inclusao-operadora',
  FIELD_DATA_LIBERACAO = 'field-data-liberacao',
  FIELD_DATA_LIMITE_UTILIZACAO = 'field-data-limite-utilizacao',
  FIELD_DATA_MIGRACAO = 'field-data-migracao',
  FIELD_DATA_REATIVACAO = 'field-data-reativacao',
  FIELD_DATA_RECISAO = 'field-data-recisao',
  FIELD_DATA_SUSPENSAO = 'field-data-suspensao',
  FIELD_DATA_VALIDADE = 'field-data-validade',
  FIELD_DATA_VALIDADE_CONSULTA = 'field-data-validade-consulta',
  FIELD_FATOR_MODERADOR = 'field-fator-moderador',
  FIELD_FORMACAO_PRECO = 'field-formacao-preco',
  FIELD_IMAGE = 'field-image',
  FIELD_IMAGE_RESPONSIVO = 'field-image-responsivo',
  FIELD_MENSAGEM_CARENCIA = 'field-mensagem-carencia',
  FIELD_NOME = 'field-nome',
  FIELD_OBSERVACAO = 'field-observacao',
  FIELD_OBSERVACAO_RESPONSIVO = 'field-observacao-responsivo',
  FIELD_PRODUTO = 'field-produto',
  FIELD_PROTOCOLO = 'field-protocolo',
  FIELD_REGULAMENTACAO = 'field-regulamentacao',
  FIELD_SEGMENTACAO = 'field-segmentacao',
  FIELD_SERVICOS = 'field-servicos',
  FIELD_SITUACAO = 'field-situacao',
  FIELD_SITUACAO_ATENDIMENTO = 'field-situacao-atendimento',
  FIELD_SITUACAO_TRABALHISTA = 'field-situacao-trabalhista',
  FIELD_SUBESTIPULANTE = 'field-subestipulante',
  FIELD_TIPO_ACOMODACAO = 'field-tipo-acomodacao',
  FIELD_TIPO_CONTRATACAO = 'field-tipo-contratacao',
  FIELD_TIPO_DOCUMENTO = 'field-tipo-documento',
  FIELD_TIPO_DOCUMENTO_RESPONSIVOS = 'field-tipo-documento-responsivos',
  FIELD_TITULAR = 'field-titular',
  FIELD_TITULARIDADE = 'field-titularidade',
  FORM_DADOS = 'form-dados',
  FORM_LOCATOR = 'form-locator',
  FORM_PRODUTO = 'form-produto',
  FORM_SERVICOS = 'form-servicos',
  HPMS_CONSULTA_BENEFICIARIO = 'hpms-consulta-beneficiario',
  HPMS_DOCUMENTOS = 'hpms-documentos',
  HPMS_DOCUMENTOS_RESPONSIVO = 'hpms-documentos-responsivo',
  IMAGE_0 = 'image-0',
  IMAGE_DOWNLOAD = 'image-download',
  IMAGE_DOWNLOAD_RESPONSIVO = 'image-download-responsivo',
  INPUT_0 = 'input-0',
  LAYOUT_0 = 'layout-0',
  LAYOUT_CTRL = 'layout-ctrl',
  LAYOUT_DADOS = 'layout-dados',
  LOCATOR_BENEFICIARIO = 'locator-beneficiario',
  LOCATOR_FIELD_0 = 'locator-field-0',
  MEDIA_QUERY = 'media-query',
  MEDIA_QUERY_REPONSIVO = 'media-query-reponsivo',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_BENEFICIARIO_DOSSIE = 'panel-beneficiario-dossie',
  PANEL_CONSULTA_BENEFICIARIO = 'panel-consulta-beneficiario',
  PANEL_DADOS = 'panel-dados',
  PANEL_DADOS_BENEF = 'panel-dados-benef',
  PANEL_DOCUMENTOS = 'panel-documentos',
  PANEL_LOCATOR = 'panel-locator',
  PANEL_MSG_DEFAULT_BENEFICIARIO = 'panel-msg-default-beneficiario',
  PANEL_PRODUTO = 'panel-produto',
  PANEL_SERVICOS = 'panel-servicos',
  PANEL_SERVICOS_FORM = 'panel-servicos-form',
  PANEL_TAB_CONTROL = 'panel-tab-control',
  REPEATER_SERVICOS = 'repeater-servicos',
  TAB_CONSULTA_BENEFICIARIO = 'tab-consulta-beneficiario',
  TAB_CONTROL_0 = 'tab-control-0',
  TAB_DADOS_BENEFICIARIO = 'tab-dados-beneficiario',
  TAB_DOSSIE_DOCUMENTOS = 'tab-dossie-documentos',
  TEXT_0 = 'text-0',
  TEXT_ABRANGENCIA_GEOGRAFICA = 'text-abrangencia-geografica',
  TEXT_CARENCIA_CONSULTA = 'text-carencia-consulta',
  TEXT_CARTEIRA = 'text-carteira',
  TEXT_CODIGO_ANTERIOR = 'text-codigo-anterior',
  TEXT_CONTRATO = 'text-contrato',
  TEXT_DATA_ADESAO = 'text-data-adesao',
  TEXT_DATA_DOCUMENTO = 'text-data-documento',
  TEXT_DATA_DOCUMENTOS_RESPONSIVO = 'text-data-documentos-responsivo',
  TEXT_DATA_INCLUSAO_OPERADORA = 'text-data-inclusao-operadora',
  TEXT_DATA_LIBERACAO = 'text-data-liberacao',
  TEXT_DATA_LIMITE_UTILIZACAO = 'text-data-limite-utilizacao',
  TEXT_DATA_MIGRACAO = 'text-data-migracao',
  TEXT_DATA_REATIVACAO = 'text-data-reativacao',
  TEXT_DATA_RECISAO = 'text-data-recisao',
  TEXT_DATA_SUSPENSAO = 'text-data-suspensao',
  TEXT_DATA_VALIDADE = 'text-data-validade',
  TEXT_DATA_VALIDADE_CONSULTA = 'text-data-validade-consulta',
  TEXT_FATOR_MODERADOR = 'text-fator-moderador',
  TEXT_FORMACAO_PRECO = 'text-formacao-preco',
  TEXT_MENSAGEM_CARENCIA = 'text-mensagem-carencia',
  TEXT_NOME = 'text-nome',
  TEXT_OBSERVACAO = 'text-observacao',
  TEXT_OBSERVACAO_RESPONSIVO = 'text-observacao-responsivo',
  TEXT_PRODUTO = 'text-produto',
  TEXT_PROTOCOLO = 'text-protocolo',
  TEXT_REGULAMENTACAO = 'text-regulamentacao',
  TEXT_SEGMENTACAO = 'text-segmentacao',
  TEXT_SERVICO = 'text-servico',
  TEXT_SITUACAO = 'text-situacao',
  TEXT_SITUACAO_ATENDIMENTO = 'text-situacao-atendimento',
  TEXT_SITUACAO_TRABALHISTA = 'text-situacao-trabalhista',
  TEXT_SUBESTIPULANTE = 'text-subestipulante',
  TEXT_TIPO_ACOMODACAO = 'text-tipo-acomodacao',
  TEXT_TIPO_CONTRATACAO = 'text-tipo-contratacao',
  TEXT_TIPO_DOCUMENTO = 'text-tipo-documento',
  TEXT_TIPO_DOCUMENTO_RESPONSIVOS = 'text-tipo-documento-responsivos',
  TEXT_TITULAR = 'text-titular',
  TEXT_TITULARIDADE = 'text-titularidade',
}
export { BeneficiarioDossieAliases };
